const CmsActionTypes = {
ABOUT_US_GET_DATA_START:'ABOUT_US_GET_DATA_START',
ABOUT_US_GET_DATA_SUCCESS:'ABOUT_US_GET_DATA_SUCCESS',
ABOUT_US_GET_DATA_FAILURE:'ABOUT_US_GET_DATA_FAILURE',
};
export default CmsActionTypes;